import { createContext } from "react";

import { MmcEditor } from "../../type/slate-types";

export type EmailContextValue = {
  bodyEditor?: MmcEditor;
  subjectEditor?: MmcEditor;
};

const emailContext = createContext<EmailContextValue>({});

export default emailContext;
